import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadProgress',
  props: {
  dialogShow: {
    type: Boolean,
    default: false,
  },
},
  emits: ['cancelExportCreateSimple'],
  setup(__props, { emit: emits }) {

const props = __props;

const m = defineMessages({
  preparingDownload:
    'ダウンロード準備中です。ファイル数が多い場合、数分かかる場合があります。',
});




const localDialogShow = ref(props.dialogShow);

watch(
  () => props.dialogShow,
  (newValue) => {
    localDialogShow.value = newValue;
  }
);

const cancelExport = () => {
  emits('cancelExportCreateSimple');
  localDialogShow.value = false;
};

return { __sfc: true,m, props, emits, localDialogShow, cancelExport, sharedMessages }
}

})